import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TogglePassword.module.scss';
import { VdsIcon } from '@volt/volt-extended-components-react';
import { CasFormInputProps } from '@cas/components/inputs/cas-form-input/CasFormInput';
import { FieldValues } from 'react-hook-form';
import VdsBasicInputSafe from '@cas/components/vds-basic-input-safe/VdsBasicInputSafe';

export interface TogglePasswordProps<TFormValues extends FieldValues = FieldValues>
  extends CasFormInputProps<TFormValues> {
  type: 'password';
}

export default function TogglePassword<TFormValues extends FieldValues = FieldValues>(
  props: TogglePasswordProps<TFormValues>,
) {
  const { t } = useTranslation();
  const [revealPassword, setRevealPassword] = useState(false);

  const effectiveType = revealPassword ? 'text' : 'password';

  const onToggle = () => {
    if (props.disabled) return;
    setRevealPassword(p => !p);
  };

  return (
    <VdsBasicInputSafe {...props} type={effectiveType}>
      <button
        type="button"
        className={styles.buttonEyePassword}
        slot="primaryActionIcon"
        onClick={onToggle}
        disabled={props.disabled}
        aria-label={revealPassword ? t('Hide password') : t('Show password')}
        aria-pressed={revealPassword}
      >
        <VdsIcon
          className={styles.iconEyePassword}
          svgIcon={revealPassword ? 'show' : 'hide'}
          size="20px"
        />
      </button>
    </VdsBasicInputSafe>
  );
}
